import "./src/styles/global.scss"

export const registerServiceWorker = () => true
